export const SET_DATE_FILTER = 'SET_DATE_FILTER';
export const SET_REPORTS_DATE_FILTER = 'SET_REPORTS_DATE_FILTER';
export const CLEAR_DATE_FILTER = 'CLEAR_DATE_FILTER';
export const SET_DOMAIN_FILTER = 'SET_DOMAIN_FILTER';
export const SET_ORGANIZATION_FILTER = 'SET_ORGANIZATION_FILTER';
export const CLEAR_ORGANIZATION_FILTER = 'CLEAR_ORGANIZATION_FILTER';
export const CLEAR_DOMAIN_FILTER = 'CLEAR_DOMAIN_FILTER';
export const SET_TYPE_FILTER = 'SET_TYPE_FILTER';
export const CLEAR_TYPE_FILTER = 'CLEAR_TYPE_FILTER';
